// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios"
import ElementUI from 'element-ui';

import config from './libs/config/config.js'
import request from './libs/api/request.js'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(config);

Vue.prototype.$axios = axios;
Vue.prototype.$request = request;

// require styles
import './assets/styles/reset.css'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/iconfont.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const role = JSON.parse(localStorage.getItem('userInfo')) || JSON.parse(sessionStorage.getItem("userInfo"));

    if(to.path == "/login"){
        next();

        return;
    }

    if(role == null && to.path !== '/login'){
        next('/login');
    } else {
        // 未开通企业版
        if(role.type == 0 && to.path !== "/corCert"){
            next("/corCert");
        } if (role.type == 1 && to.path !== "/notallow"){
            next("/notallow");
        } if (role.type == 2 ) {
            if(role.status == 0 && to.path !== "/notallow"){
                next("/notallow");
            } else {
                // next();
            }
        } if(role.type == 3 && to.path !== "/notallow"){
            next("/notallow");
        } else {
            next();
        }
    }  
})



// WEBPACK FOOTER //
// ./src/main.js